import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const DOCUMENTS = [
  { id: 'notice_utilisation', label: "Notice d'utilisation" },
  { id: 'certificat_ce', label: 'Certificat CE ou déclaration de conformité' },
  { id: 'carnet_maintenance', label: 'Carnet de maintenance' },
  { id: 'precedent_rapport', label: 'Précédent rapport' }
];

const MOTIFS_NON_CONTROLE = [
  { value: 'immobilise', label: 'Appareil immobilisé' },
  { value: 'panne', label: 'Appareil en panne' },
  { value: 'conditions_securite', label: "Les conditions d'essai en sécurité ne sont pas réunies" },
  { value: 'non_presente', label: 'Machine non présentée' }
];

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#065f46',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  documentRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    background: '#f9fafb',
    borderRadius: '8px',
    marginBottom: '8px',
    border: '1px solid #e5e7eb'
  },
  documentLabel: {
    fontSize: '14px',
    color: '#374151',
    fontWeight: '500',
    flex: 1
  },
  radioGroup: {
    display: 'flex',
    gap: '16px'
  },
  radioOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    cursor: 'pointer'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    cursor: 'pointer'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '12px',
    background: '#dcfce7',
    border: '2px solid #10b981',
    borderRadius: '12px',
    cursor: 'pointer'
  },
  checkboxLabelWarning: {
    background: '#fef3c7',
    border: '2px solid #f59e0b'
  },
  checkboxLabelDanger: {
    background: '#fee2e2',
    border: '2px solid #ef4444'
  },
  checkboxText: {
    fontSize: '14px',
    color: '#065f46',
    lineHeight: '1.5'
  },
  collapsibleContent: {
    marginTop: '12px',
    paddingLeft: '32px'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

function Etape5DocumentationEssaisMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({
    documents: {},
    charge_essai: '',
    essais_realises_cmu: false,
    essais_equipements_presentes: false,
    phrase_supplementaire: false,
    precisions_essais: '',
    appareil_non_controle: false,
    motif_non_controle: '',
    motif_non_controle_autre: '',
    prix_controle: '',
    bon_commande: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_5_documentation_essais_levage');
      if (savedData) {
        setData(prev => ({ ...prev, ...savedData }));
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const handleDocumentChange = (docId, statut) => {
    setData(prev => ({
      ...prev,
      documents: {
        ...prev.documents,
        [docId]: statut
      }
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_5_documentation_essais_levage', data);
      console.log('✅ Étape 5 levage sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#10b981', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#065f46', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Documentation & Essais</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Documentation */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📄 Documentation présentée</h3>
          
          {DOCUMENTS.map(doc => {
            const statut = data.documents[doc.id] || 'non_presente';
            
            return (
              <div key={doc.id} style={styles.documentRow}>
                <span style={styles.documentLabel}>{doc.label}</span>
                <div style={styles.radioGroup}>
                  <label style={styles.radioOption}>
                    <input
                      type="radio"
                      name={doc.id}
                      checked={statut === 'presente'}
                      onChange={() => handleDocumentChange(doc.id, 'presente')}
                    />
                    <span style={{ fontSize: '13px' }}>Oui</span>
                  </label>
                  <label style={styles.radioOption}>
                    <input
                      type="radio"
                      name={doc.id}
                      checked={statut === 'non_presente'}
                      onChange={() => handleDocumentChange(doc.id, 'non_presente')}
                    />
                    <span style={{ fontSize: '13px' }}>Non</span>
                  </label>
                </div>
              </div>
            );
          })}
        </div>

        {/* Essais */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>⚡ Réalisation des essais</h3>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Charge utilisée (kg)</label>
            <input
              type="number"
              style={styles.input}
              value={data.charge_essai}
              onChange={(e) => handleChange('charge_essai', e.target.value)}
              placeholder="Ex: 2660"
            />
          </div>

          {/* Checkbox CMU */}
          <label style={styles.checkboxLabel}>
            <input
              type="checkbox"
              style={styles.checkbox}
              checked={data.essais_realises_cmu}
              onChange={(e) => handleChange('essais_realises_cmu', e.target.checked)}
            />
            <span style={styles.checkboxText}>
              Les essais ont été réalisés à la charge Maximale d'Utilisation (CMU)
            </span>
          </label>

          {/* Checkbox équipements présentés */}
          <label style={{ ...styles.checkboxLabel, marginTop: '12px' }}>
            <input
              type="checkbox"
              style={styles.checkbox}
              checked={data.essais_equipements_presentes}
              onChange={(e) => handleChange('essais_equipements_presentes', e.target.checked)}
            />
            <span style={styles.checkboxText}>
              Les essais de fonctionnement ont été réalisés avec les équipements présentés lors de la visite
            </span>
          </label>

          {/* Phrase supplémentaire */}
          <label style={{ ...styles.checkboxLabel, ...styles.checkboxLabelWarning, marginTop: '12px' }}>
            <input
              type="checkbox"
              style={styles.checkbox}
              checked={data.phrase_supplementaire}
              onChange={(e) => handleChange('phrase_supplementaire', e.target.checked)}
            />
            <span style={{ ...styles.checkboxText, color: '#92400e' }}>
              Les essais ont été réalisés avec les charges mises à disposition. 
              Le chef d'établissement doit prendre les dispositions visant à restreindre 
              l'utilisation de l'équipement à cette charge ou faire procéder à de nouveaux 
              essais sous charge nominale.
            </span>
          </label>

          {/* Précisions */}
          <div style={{ ...styles.formGroup, marginTop: '16px' }}>
            <label style={styles.label}>Précisions sur les essais</label>
            <textarea
              style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }}
              value={data.precisions_essais}
              onChange={(e) => handleChange('precisions_essais', e.target.value)}
              placeholder="Informations complémentaires..."
            />
          </div>
        </div>

        {/* Appareil non contrôlé */}
        <div style={styles.card}>
          <label style={{ ...styles.checkboxLabel, ...styles.checkboxLabelDanger }}>
            <input
              type="checkbox"
              style={styles.checkbox}
              checked={data.appareil_non_controle}
              onChange={(e) => {
                handleChange('appareil_non_controle', e.target.checked);
                if (!e.target.checked) {
                  handleChange('motif_non_controle', '');
                  handleChange('motif_non_controle_autre', '');
                }
              }}
            />
            <span style={{ ...styles.checkboxText, color: '#991b1b', fontWeight: '700' }}>
              ⚠️ Appareil non contrôlé
            </span>
          </label>

          {data.appareil_non_controle && (
            <div style={styles.collapsibleContent}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Motif *</label>
                <select
                  style={styles.select}
                  value={data.motif_non_controle}
                  onChange={(e) => handleChange('motif_non_controle', e.target.value)}
                >
                  <option value="">Sélectionner...</option>
                  {MOTIFS_NON_CONTROLE.map(m => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                  ))}
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Précisions complémentaires</label>
                <textarea
                  style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }}
                  value={data.motif_non_controle_autre}
                  onChange={(e) => handleChange('motif_non_controle_autre', e.target.value)}
                  placeholder="Détails supplémentaires..."
                />
              </div>
            </div>
          )}
        </div>

        {/* Prix et bon de commande */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>💰 Facturation</h3>
          
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Prix du contrôle (€)</label>
              <input
                type="number"
                step="0.01"
                style={styles.input}
                value={data.prix_controle}
                onChange={(e) => handleChange('prix_controle', e.target.value)}
                placeholder="57.00"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>N° Bon de commande</label>
              <input
                type="text"
                style={styles.input}
                value={data.bon_commande}
                onChange={(e) => handleChange('bon_commande', e.target.value)}
                placeholder="BC-2023-001"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape5DocumentationEssaisMobile;